const NOW = new Date();
const NOW_SECONDS = NOW.getTime() / 1000;
const ONE_MONTH_SECONDS = 2592000; // 30 * 24 * 60 * 60 = 30 days

export const isRecentlyCreated = (createdAtSeconds: number): boolean => {
  return NOW_SECONDS - createdAtSeconds <= ONE_MONTH_SECONDS;
};
